module.exports = __webpack_public_path__ + "img/干姜.0e0199d8.jpg";